import styled from "styled-components";
export const ListElement = styled.div `
  counter-reset: list-counter;
  padding: 0 0 0 1rem;
  ul,
  ol {
    padding: 0;
  }
  list-style: ${({ ordered }) => (ordered ? "ordered" : "none")};
`;
ListElement.displayName = "ListElement";
